module.exports = __webpack_public_path__ + "public/SiteImages/logo.png?81ba0e6b";